import {Component, Input, OnInit} from '@angular/core';
import {FormArray, FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {PortalServiceFactoryService} from '../../../../services/portal-service-factory.service';
import {VnaPortalConfigDataParserService} from '../../../../vna_portal/services/vna-portal-config-data-parser.service';
import {MiscelaneaService} from '../../../../../../shared/services/miscelanea.service';
import {Observable} from 'rxjs/Observable';
import {PortalService} from '../../../../vna_portal/model/PortalService';
import {AlertaService} from '../../../../../../shared/services/alerta.service';
import {CallRangeAllowedComponent} from '../../call-range-allowed/call-range-allowed.component';

import * as _ from 'underscore';

@Component({
  selector: 'app-beeztel-call-range-allowed',
  templateUrl: './beeztel-call-range-allowed.component.html',
  styleUrls: ['./beeztel-call-range-allowed.component.scss']
})
export class BeeztelCallRangeAllowedComponent extends CallRangeAllowedComponent implements OnInit {

    ranges: any = [];
    hoursCall: any = [];
    daysHoursAllowed: any = [];

    weekDays: Array<Object> = [];

    constructor(protected formBuilder: FormBuilder, protected portalServiceFactory: PortalServiceFactoryService, protected dataParser: VnaPortalConfigDataParserService, protected miscHandler: MiscelaneaService, protected alertHandler: AlertaService) {

        super(formBuilder, portalServiceFactory, dataParser, miscHandler, alertHandler);

        this.form.setControl('requeue_ranges', this.formBuilder.array([]));
        this.form.setControl('hours_to_add_out_of_range', this.formBuilder.array([]));
        this.form.setControl('status_requeue', new FormControl());
        this.form.setControl('days_allowed_hours', this.formBuilder.array([]));
        this.form.setControl('week_days_allowed', new FormControl());
        this.form.setControl('hours_range_timezone', new FormControl());

        this.weekDays = [
            {'value': 1, 'display': 'Monday'},
            {'value': 2, 'display': 'Tuesday'},
            {'value': 3, 'display': 'Wednesday'},
            {'value': 4, 'display': 'Thursday'},
            {'value': 5, 'display': 'Friday'},
            {'value': 6, 'display': 'Saturday'},
            {'value': 7, 'display': 'Sunday'},
        ];
    }

    requestAutocompleteItems = (text: string): Observable<any> => {
        return this.miscHandler.findAvailableStatus().map(
            (rows: Array<Object>) => {
                return rows.map( (o) => {
                    return o['status'];
                })
            }
        );
    };

    getUpdateData(): Object {
        let updateData = super.getUpdateData();
        updateData['call_requeue_time_ranges'] = this.form.value['requeue_ranges'];
        updateData['days_allowed_hours'] = this.form.value['days_allowed_hours'];

        updateData['hours_to_add_out_of_range'] = {};
        this.form.value['hours_to_add_out_of_range'].forEach( (o) => {
            updateData['hours_to_add_out_of_range'][o['hour_call']] = o['hours_to_add'];
        });

        updateData['status_requeue'] = (_.isArray(this.form.value['status_requeue'])) ? this.form.value['status_requeue'].map( (o) => { return o['value'] }) : [];
        updateData['week_days_allowed'] = (_.isArray(this.form.value['week_days_allowed'])) ? this.form.value['week_days_allowed'].map( (o) => { return o['value'] }) : [];

        updateData['hours_range_timezone'] = this.form.value['hours_range_timezone'];

        return updateData;

    }

    addRange(data?: Object): void {
        this.ranges = this.form.get('requeue_ranges') as FormArray;
        this.ranges.push(this.createRange(data));
    }

    addHourToCall(data?: Object): void {
        this.hoursCall = this.form.get('hours_to_add_out_of_range') as FormArray;
        this.hoursCall.push(this.createHourToAdd(data));
    }

    addDayAllowedHours(data?: Object): void {
        this.daysHoursAllowed = this.form.get('days_allowed_hours') as FormArray;
        this.daysHoursAllowed.push(this.createDayAllowedHours(data));
    }

    removeRange(i: number): void {
        this.ranges.removeAt(i);
    }

    removeHourCall(i: number): void {
        this.hoursCall.removeAt(i);
    }

    removeDayHoursAllowed(i: number) {
        this.daysHoursAllowed.removeAt(i);
    }

    ngOnInit() {

        super.ngOnInit();

        if(this.portalService.hasCallRequeueTimeRanges()){
            this.portalService.getCallRequeueTimeRanges().forEach( (range: Object) => {
                this.addRange(range);
            });
        }

        if(this.portalService.hasHoursToAddOutOfRange()){
            const hoursToCall: Object = this.portalService.getHoursToAddOutOfRange();
            for(let hour in hoursToCall){
                this.addHourToCall({ hour_call : hour, hours_to_add: hoursToCall[hour] });
            }
        }

        if(this.portalService.hasStatusRequeue()){
            this.form.controls['status_requeue'].setValue(this.portalService.config['status_requeue'].map( (value) => {
                return {'value' : value, 'display' : value };
            } ));
        }

        if(this.portalService.hasWeekDaysAllowed()){
            this.form.controls['week_days_allowed'].setValue(this.portalService.config['week_days_allowed'].map( (value) => {
                return this.findWeekDayByValue(value);
            } ));
        }

        if(this.portalService.hasDaysAllowedHours()){
            this.portalService.getDaysAllowedHours().forEach((dayAllowedHour: Object) => {
                this.addDayAllowedHours(dayAllowedHour);
            })
        }

        if(this.portalService.hasHoursRangeTimezone()) {
          this.form.controls['hours_range_timezone'].setValue(this.portalService.getConfigKey('hours_range_timezone'));
        }

    }

    createRange(data?: Object): FormGroup {
        let rangeData = (data) ? data : { from: '', to: '', hours_to_add: '' };
        return this.formBuilder.group({
            from: new FormControl(rangeData['from'], Validators.required),
            to: new FormControl(rangeData['to'], Validators.required),
            order: new FormControl(rangeData['order'], Validators.required),
            hours_to_add: new FormControl(rangeData['hours_to_add'], Validators.required)
        });
    }

    createHourToAdd(data?: Object): FormGroup {
        let hourToCallData = (data) ? data : { hour_call: '', hours_to_add: '' };
        return this.formBuilder.group({
            hour_call: hourToCallData['hour_call'],
            hours_to_add: hourToCallData['hours_to_add']
        });
    }

    createDayAllowedHours(data?: Object): FormGroup {
        let dayAllowedHoursData = (data) ? data : {week_day : '', from: '', to: ''};
        return this.formBuilder.group({
            week_day: dayAllowedHoursData['week_day'],
            from: dayAllowedHoursData['from'],
            to: dayAllowedHoursData['to']
        });
    }

    protected findWeekDayByValue(value): Object {
        let idx = _.findIndex(this.weekDays, (o) => {
            return o.value == value;
        });

        return this.weekDays[idx];
    }

}



// WEBPACK FOOTER //
// /var/www/backend/src/app/phone/config/form/components/beeztel/beeztel-call-range-allowed/beeztel-call-range-allowed.component.ts